export default "__VITE_ASSET__3e74109e__"